// 通用配置
export * from './interface/config';
export { default as Layer } from './base/layer';
export { default as ViewLayer } from './base/view-layer';
export { default as Base } from './base/plot';
// 图形
export * from './plots';
export { default as Progress } from './sparkline/progress';
export { default as RingProgress } from './sparkline/ring-progress';
export { default as TinyColumn } from './sparkline/tiny-column';
export { default as TinyArea } from './sparkline/tiny-area';
export { default as TinyLine } from './sparkline/tiny-line';
// 混合图形
export { default as DualLine } from './combo/dual-line';
export { default as ColumnLine } from './combo/column-line';
export { default as GroupedColumnLine } from './combo/groupedColumn-line';
export { default as StackedColumnLine } from './combo/stackedColumn-line';
// 主题
export { registerTheme, registerGlobalTheme } from './theme';
export { registerResponsiveConstraint } from './util/responsive/constraints';
export { registerResponsiveRule } from './util/responsive/rules';
export { registerResponsiveTheme, getResponsiveTheme } from './util/responsive/theme';
export { default as StateManager } from './util/state-manager';
// 导出 g2 上层需要使用
import * as G2 from '@antv/g2';
export { G2 };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/index.js
// module id = null
// module chunks = 